<template>
  <v-snackbar v-model="active" :color="color" :top="true">
    <span>{{ message }}</span>
    <v-btn dark text @click="active = false">
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  computed: {
    ...mapGetters({
      hasError: "errors/has",
      getError: "errors/get",
    }),

    active: {
      get: function () {
        return this.getError("error");
      },
      set: function (v) {
        if (v == false) this.$store.dispatch("errors/unset", "error");
      },
    },

    message: function () {
      return this.getError("error");
    },

    color: function () {
      return "error";
    },
  },

  mounted: function () {
    this.$store.subscribe(({ type, payload }, state) => {
      if (type == "errors/put" && payload.key == "error") {
        this.$forceUpdate();
      }
    });
  },
};
</script>